module.exports = __webpack_public_path__ + "img/dash1.9e271bc5.png";